<template>
  <div id="Bannerlist">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">管理人員操作日誌</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">操作日誌</li>
              <li class="breadcrumb-item active">管理人員操作日誌</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-banner" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-10">
            <div class="b-filter">
              <el-button
                @click="selectByType('')"
                :class="{ current: '' == selectValue }"
                >全部</el-button
              >
              <el-button
                @click="selectByType('影音')"
                :class="{ current: '影音' == selectValue }"
                >影音</el-button
              >
              <el-button
                @click="selectByType('活動')"
                :class="{ current: '活動' == selectValue }"
                >活動</el-button
              >
              <el-button
                @click="selectByType('話題')"
                :class="{ current: '話題' == selectValue }"
                >話題</el-button
              >
              <el-button
                @click="selectByType('用戶')"
                :class="{ current: '用戶' == selectValue }"
              >
                用戶</el-button
              >
              <el-button
                @click="selectByType('相薄')"
                :class="{ current: '相薄' == selectValue }"
                >相薄</el-button
              >
              <el-button
                @click="selectByType('留言')"
                :class="{ current: '留言' == selectValue }"
                >留言</el-button
              >
              <el-button
                @click="selectByType('主页')"
                :class="{ current: '主页' == selectValue }"
                >主页</el-button
              >
              <el-button
                @click="selectByType('用户短視頻')"
                :class="{ current: '用户短視頻' == selectValue }"
                >用户短視頻</el-button
              >
              <el-button
                @click="selectByType('檢舉內容')"
                :class="{ current: '檢舉內容' == selectValue }"
                >檢舉內容</el-button
              >
              <el-button
                @click="selectByType('廣告')"
                :class="{ current: '廣告' == selectValue }"
                >廣告</el-button
              >
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <div class="card">
              <div class="demo-input-size row margs"></div>
              <div class="card-body">
                <el-form
                  ref="form"
                  label-width="80px"
                  @submit.native.prevent
                  :inline="true"
                >
                  <el-row>
                    <el-col
                      :md="{ span: 24 }"
                      :sm="{ span: 24 }"
                      :xs="{ span: 24 }"
                      style="text-align: right"
                    >
                      <el-form-item label="搜尋:">
                        <el-input
                          placeholder="请输入内容"
                          v-model="searchText"
                          clearable
                          @input="searchTextQry"
                        >
                        </el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-input
                          placeholder="请输入接口地址"
                          v-model="SGL_MenuPersionName"
                          clearable
                          @input="searchTextQry"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>

                <el-table
                  :data="GetList"
                  v-loading="loading"
                  border
                  row-key="id"
                >
                  <el-table-column label="操作時間" prop="sgL_CreateTimeS">
                  </el-table-column>
                  <el-table-column label="操作人" prop="sgL_CreateName">
                  </el-table-column>
                  <el-table-column label="IP" prop="sgL_Ip"> </el-table-column>
                  <el-table-column label="板塊" prop="sgL_Type">
                  </el-table-column>
                  <el-table-column
                    label="操作事項"
                    prop="sgL_Remark"
                  ></el-table-column>
                  <el-table-column label="操作数据" prop="sgL_CreateTimeM">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="look(scope.row.sgL_RequestJson)"
                        >查看</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- /.card-body -->
            </div>
            <div class="row">
              <div class="col-lg-4 offset-lg-7">
                <!--  引用分页组件 -->
                <pagination
                  v-if="pageParams.pageshow"
                  :currentPage="pageParams.currentPage"
                  :total="pageParams.total"
                  :limit="pageParams.limit"
                  :small="true"
                  @handleCurrentChange="handleCurrentChange"
                  @handleSizeChange="handleSizeChange"
                />
              </div>
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
    <el-dialog
      title="操作数据"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span>{{ dialogContent }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="cp">複製</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Message } from "element-ui";
import pagination from "../common/Page";
export default {
  data() {
    return {
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "true",
          label: "顯示中",
        },
        {
          value: "false",
          label: "隱藏中",
        },
      ],
      SGL_MenuPersionName: "",
      dialogVisible: false,
      dialogContent: "",
      searchText: "",
      selectValue: "",
      // BannerList: null,
      BannerList: [],
      pageParams: {
        pageshow: true,
        currentPage: 1, //當前頁
        total: 0, //總條數
        limit: 10, //顯示條數
      },
      loading: true,
    };
  },
  created() {
    this.getBannerList();
  },
  watch: {
    selectValue: {
      handler(newvalue, oldvalue) {
        this.handleCurrentChange(1);
      },
    },
  },
  methods: {
    cp() {
      this.copyToClipboard(this.dialogContent, true);
    },
    look(txt) {
      this.dialogContent = txt;
      this.dialogVisible = true;
    },
     handleClose (done) {
      done();
    },
    getBannerList() {
      this.loading = true;
      let params = {
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
        SGL_RequestId: this.searchText,
        SGL_Type: this.selectValue,
        SGL_MenuPersionName: this.SGL_MenuPersionName,
        SGL_IsAdmin: true,
      };
      this.$api.permissionApi
        .GetLogList(params)
        .then((res) => {
          if (res.data.success) {
            this.BannerList = res.data.result.items;
            this.pageParams.total = res.data.result.totalCount;
          } else {
            Message({
              type: "error",
              message: res.data.error.message,
            });
          }
        })
        .catch((err) => {
          Message({
            type: "error",
            message: err,
          });
          this.loading = false;
        })
        .then((obj) => {
          this.loading = false;
        });
    },
    selectByType(status) {
      this.selectValue = status;
    },
    searchTextQry() {
      this.handleCurrentChange(1);
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getBannerList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getBannerList();
    },
  },
  components: {
    pagination,
  },
  computed: {
    GetList() {
      return this.BannerList;
    },
  },
};
</script>

<style scoped>
.filter .current {
  background-color: #2e3e4a;
  color: #fff !important;
}

/* .b-ad-name a {
  display: inline-block;
  position: relative;
}
.b-ad-name a img {
  display: none;
  position: absolute;
  z-index: 1100;
  min-height: 90px;
  max-height: 500px;
  top: 50%;
  left: calc(100% + 1rem);
  transform: translateY(-50%);
} */
</style>


// WEBPACK FOOTER //
// src/components/AdminLog/adminLog.vue